const commonDeliverableExtensions = ['gif', 'png', 'jpeg', 'pdf', 'mp4', 'avi', 'mov'];

export default commonDeliverableExtensions;
